export default __webpack_public_path__ + "static/media/simulation.4f6dde34.svg";